module.exports = __webpack_public_path__ + "h5/img/ecards.4a3fdfb0.png";